module.exports = __webpack_public_path__ + "Roboto-Thin.954bbdeb86483e4ffea0.woff2";


//////////////////
// WEBPACK FOOTER
// C:/Users/Ludo.DESKTOP-F1GO0J2/PhpstormProjects/orderApi/orderApp/src/font/roboto/Roboto-Thin.woff2
// module id = ../../../../../src/font/roboto/Roboto-Thin.woff2
// module chunks = 1